// Initializes Slick Carousel on every product-slider block (deal-of-day,
// bogo-strip, featured-group, bestsellers, new-in). One instance per element
// on the page — never a single global selector — since the homepage has up
// to 5 of these blocks at once.
// Uses the bare `$` global (provided by webpack.config.js's ProvidePlugin,
// same as home.js) — NOT window.jQuery, see hero-slider.js for why.

// Custom arrow markup: Slick's default arrows render their glyph via a
// `slick` icon webfont we never loaded, so with just `arrows: true` the
// buttons show up as empty circles. `stroke="currentColor"` lets the chevron
// follow .slick-arrow's own text color (including on :hover) with no extra CSS.
const prevArrow = '<button type="button" class="slick-prev" aria-label="Previous"><svg width="18" height="18" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="12.5 5 7.5 10 12.5 15"/></svg></button>';
const nextArrow = '<button type="button" class="slick-next" aria-label="Next"><svg width="18" height="18" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="7.5 5 12.5 10 7.5 15"/></svg></button>';

function init() {
    $('.product-slider__track').each(function () {
        const $track = $(this);
        if ($track.hasClass('slick-initialized')) return;

        $track.slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            rows: 0, // disable Slick's grid-row wrapper, see hero-slider.js
            arrows: true,
            prevArrow,
            nextArrow,
            infinite: false,
            // Below lg the source design (ProductSlider.tsx) switches from
            // arrow navigation to a snap-scroll strip with a partial "peek"
            // of the next card (basis-[80%] / sm:basis-[45%]) — the peek is
            // the swipe affordance, so arrows go away entirely (they also
            // overlapped card text at these sizes). Fractional slidesToShow
            // reproduces the peek; it needs infinite:false (set above).
            responsive: [
                { breakpoint: 1280, settings: { slidesToShow: 3 } },
                { breakpoint: 1024, settings: { slidesToShow: 2.15, arrows: false } },
                { breakpoint: 640, settings: { slidesToShow: 1.25, arrows: false } },
            ],
        });
    });
}

export default { init };
